import { BillingCycle, Customer, SubscriptionItem, SubscriptionStatus } from "../../api/proxies";

export enum SubscriptionStatusEnum {
    Incomplete = 0,
    IncompleteExpired = 1,
    Trialing = 3,
    Active = 4,
    PastDue = 5,
    Unpaid = 6,
    Canceled = 7,
    Cancelling = 71,
    Archived = 8,
    Internal = 254,
}

export class CreditCard {
    flag: string;

    token: string;

    number: string;

    expirationMonth: string;

    expirationYear: string;

    securityCode: string;

    ownerName: string;
}

export class SubscriptionBilling {
    dueDate: Date;
    price: number;
    paymentLink: string | undefined;
}

export interface ISubscriptionDetailsState {
    customer: Customer;

    editionName: string | undefined;

    price: number;

    currentPrice: number;

    billingCycle: BillingCycle;

    startDate: Date;

    items: SubscriptionItem[] | undefined;

    loading: boolean;

    isEditingCreditCard: boolean;

    status: SubscriptionStatus;

    loadingActiveBillings: boolean;

    due: SubscriptionBilling[] | undefined;

    future: SubscriptionBilling[] | undefined;
}
